import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate: 'PROJECT_TYPE_UPDATE',
    smsDelete: 'PROJECT_TYPE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state: {
        projectType:[],
        projectTypeLoading: false,
        projectTypeError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        ...store
    },

    mutations: {
        ...mutations,

        SET_PROJECT_TYPE(state, items) {
            state.projectType = items
        },

        PROJECT_TYPE_LOADING (state, loading) {
            state.projectTypeLoading = loading;
        },

        PROJECT_TYPE_ERROR (state, hasError) {
            state.projectTypeError = hasError;
        },

     

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
       async fetchProjectType ({ commit }) {
            commit('PROJECT_TYPE_LOADING', true);
            commit('PROJECT_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_project_type, config);
                let items = result.data.data

                commit('SET_PROJECT_TYPE', items);

            } catch(error) {
                commit('PROJECT_TYPE_ERROR', true);
            }
            finally {
                commit('PROJECT_TYPE_LOADING', false);
            }
           
        },
         async addProjectType ({commit, dispatch}, payload) {
            commit('PROJECT_TYPE_LOADING', true);
            commit('PROJECT_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_project_type, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchProjectType')
                return response

            }catch (e) {
                commit('PROJECT_TYPE_ERROR', true);
            }finally {
                commit('PROJECT_TYPE_LOADING', false);
            }
        },
         async updateProjectType ({commit, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                  }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,

                async () => {
                    response = await axios.patch(V1API.edit_project_type + payload.id, {
                        title: payload.title,
                        

                    }, config).then(result => {
                        let data = decode(result.data)
                        return data
                    })

                    dispatch('fetchProjectType');

                }
            )
            return response
        },
         async deleteProjectType ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_project_type + payload, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchProjectType');

            return response
        },

    },

    getters: {}
}
